import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const SimpleListStyled = styled.ul``;

export const ListTitle = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0px;
`;

export const ListSubtitle = styled.p<{ type: 'default' | 'warning' }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) =>
    props.type === 'default'
      ? props.theme.atlas.semantic.color.type.muted
      : props.theme.atlas.semantic.color.action.destructive.default};
  margin: 0px;
`;

export const ListItem = styled.li`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0px;
`;
